<button
    type="button"
    class="account"
    aria-haspopup="menu"
    [attr.aria-label]="'menu.shell.account' | translate"
    (click)="menu.toggle($event)">
    <span class="account__avatar" aria-hidden="true">{{ initials }}</span>
    <span class="account__identity">
        <span class="account__name">{{ displayName }}</span>
        @if (name && email) {
            <span class="account__email">{{ email }}</span>
        }
    </span>
    <span class="account__more material-symbols-outlined icon-md" aria-hidden="true">unfold_more</span>
</button>
<p-menu #menu [model]="items" [popup]="true" appendTo="body">
    <!-- Material Symbols, like the sidebar: p-menu's own icon slot only takes a class name. -->
    <ng-template #item let-item>
        @if (item === languageItem) {
            <div class="p-menu-item-link">
                <span
                    class="p-menu-item-icon account-menu__icon material-symbols-outlined icon-md"
                    aria-hidden="true"
                    >{{ item.icon }}</span
                >
                <span class="p-menu-item-label">{{ item.label }}</span>
                <span class="account-menu__codes" role="group" [attr.aria-label]="item.label">
                    @for (language of languages; track language) {
                        <button
                            type="button"
                            class="account-menu__code"
                            [class.is-active]="language === currentLanguage"
                            [attr.aria-pressed]="language === currentLanguage"
                            [attr.title]="'common.languages.' + language | translate"
                            (click)="languageChange.emit(language)">
                            {{ language | uppercase }}
                        </button>
                    }
                </span>
            </div>
        } @else {
            <a
                class="p-menu-item-link"
                tabindex="-1"
                [routerLink]="item.routerLink"
                [attr.data-testid]="item.automationId">
                <span
                    class="p-menu-item-icon account-menu__icon material-symbols-outlined icon-md"
                    aria-hidden="true"
                    >{{ item.icon }}</span
                >
                <span class="p-menu-item-label">{{ item.label }}</span>
            </a>
        }
    </ng-template>
</p-menu>
